import request from "@/utils/request";

export function queryShopUserList(params) {
  return request({
    url: "/api/system/shopUser/getShopUser",
    method: "post",
    data: params
  });
}

export function updateShopUser(params) {
  return request({
    url: "/api/system/shopUser/updateShopUser",
    method: "post",
    data: params
  });
}

export function findByShopUser(params) {
  return request({
    url: "/api/system/shopUser/findByShopUser",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/mine/getUser.js